module.exports = __webpack_public_path__ + "img/BannerCompatibilidad1920x300.379bfaf3.jpg";